import React, { Component } from "react";
import lasc from "./images/lasc.jpg";
import { Link } from "react-router-dom";

class Header extends Component {
  render() {
    return (
      <>
        <div style={headerStyle}>
          <Link style={linkStyle} to="">
            <h1 style={titleStyle}>Isabella Alcañiz</h1>
          </Link>
          <p style={headerTextStyle}>
            Director | Latin American and Caribbean Studies Center | University
            of Maryland{" "}
          </p>
          <p style={headerTextStyle}>
            Associate Professor | Department of Government and Politics{" "}
          </p>
          <a href="http://www.lasc.umd.edu/" target="_blank">
            {/* <div style={lascBox}>
              <img
                src={lasc}
                alt="Latin American and Caribbean Studies Center"
                style={lascStyle}
              />
            </div> */}
          </a>
        </div>
      </>
    );
  }
}

const titleStyle = {
  fontFamily: "Lora, serif",
  fontSize: "40px",
  marginBottom: "6px",
};

const headerTextStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "18px",
  color: "white",
};

const headerStyle = {
  width: "100%",
  backgroundColor: "#2C3737",
  margin: "auto",
  padding: "10px 0px 20px 0px",
  textAlign: "center",
  color: "white",
  zIndex: "5000",
  position: "relative",
};

const lascBox = {
  width: "100px",
  height: "140px",
  position: "absolute",
  right: "80px",
  top: "1px",
};

const lascStyle = {
  height: "100%",
};

const linkStyle = {
  color: "white",
};

export default Header;
